module.exports = __webpack_public_path__ + "static/landing-page-banner-2-dfc197117f9b714ba9674b6601529a08.png";